import { getGroupFilesHubFREStore } from '../store/GroupFilesHubFREStore';
import { mutatorAction } from 'satcheljs';

export const setShouldShowFRECallouts = mutatorAction(
    'setShouldShowFRECallouts',
    async function setShouldShowFRECallouts(shouldShow: boolean) {
        getGroupFilesHubFREStore().shouldShowFRECallouts = shouldShow;
    }
);
